module.exports = __webpack_public_path__ + "img/industrialoven_2.fd4922d8.svg";